export default function Field() {
    this.name = null;
    this.title = null;
    this.header = null;
    this.type = "string";
    this.showInGrid = false;
    this.showInForm = false;
    this.altText = "";
    this.viewLevel = 4;
    this.updateLevel = 4;
    this.keyField = false;
    this.defaultValue = null;
    this.fillspace = true;
    this.adjust = true;
    this.sort = "server";
    this.hidden = false;
    this.view = "text";
    this.required = false;
    this.invalidMessage = null;
}
